<template>
  <button
    :class="`
    chip
    font-cera-pro
    text-midnight flex
    items-center
    py-2.5 px-4
    border-2 border-solid ${
      active ? 'border-green' : 'border-white m:hover:border-green'
    }
    rounded cursor-pointer
    ${backgroundColor}
    `"
    @click="onClick"
    :data-test-is-active="active"
    ref="container">
    <sprite
      :id="`category/${sprite}`"
      class="w-6 h-6 mr-2 whitespace-normal chip__sprite text-midnight" />
    <span :class="labelClasses">
      {{ label }}
    </span>
  </button>
</template>

<script>
import Sprite from "@/shared/sprite";

export default {
  name: "Chip",
  components: { Sprite },
  props: {
    sprite: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: "bg-white"
    },
    labelClasses: {
      type: String,
      default: "block whitespace-nowrap"
    }
  },
  methods: {
    onClick(e) {
      e.preventDefault();
      this.$emit("click", this.slug);
    }
  }
};
</script>
